// AUTO-GENERATED from services/app-api-service/codeigniter/application/contracts/FranchisorChannels_TriggerRow.php
// Do not edit by hand — edit the PHP RowContract and the sync hook will regenerate this file.
// Bulk regeneration: scripts/sync-contracts/sync-all.sh

/**
 * FranchisorChannels_TriggerRow — one row of the Full-only trigger matrix
 * (GET /franchisor-channels/triggers): a FranchisorTriggerCatalog entry
 * plus every binding currently saved against it.
 *
 * `implemented=false` is the "em breve" state (docs/billing-franchisor-channels.md
 * anti-mentira rule) — the console still lets staff PREPARE bindings against
 * it, but trigger_save refuses an ENABLE with 'trigger_not_implemented'.
 *
 * `bindings` holds the row objects themselves (typed, per FranchisorChannels_BindingRow[])
 * — this row's own toArray() reflects them as-is; the response wrapper
 * (FranchisorChannels_TriggersResponse) is what flattens the whole rows[]
 * list via toArray(), and PHP's json_encode serializes the nested
 * BindingRow objects' public properties natively either way.
 */
import type { FranchisorChannels_BindingRow } from './FranchisorChannels_BindingRow'
import { registerContract } from './validate'

export interface FranchisorChannels_TriggerRow {
trigger_key?: string
implemented?: boolean
vars?: string[]
bindings?: FranchisorChannels_BindingRow[]
}

registerContract('FranchisorChannels_TriggerRow', {
  trigger_key: { type: 'string',  required: false },
  implemented: { type: 'boolean', required: false },
  vars:        { type: 'array',   required: false },
  bindings: {
    type: 'array',
    required: false,
    items: {
      id:               { type: 'number',  required: true },
      trigger_key:      { type: 'string',  required: false },
      channel_id:       { type: 'number',  required: true },
      channel_type:     { type: 'string',  required: false },
      template_id:      { type: 'number',  required: true },
      recipient_groups: { type: 'array',   required: false },
      enabled:          { type: 'boolean', required: false },
      created_at:       { type: 'string',  required: false },
      updated_at:       { type: 'string',  required: false },
    },
  },
})
